export default __webpack_public_path__ + "static/media/19.b82eb34f.jpg";